<template>
  <div class="container py-4">
    <p class="body-2-2 mb-0 text-center">
      Copyright © {{today.getFullYear()}} {{getMerchant.name}} All Right Reserved
    </p>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed:{
      ...mapGetters(['getMerchant']),
      today(){
        return new Date
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ticket/CustomFooter.vue